import { WritableSignal } from "@angular/core";
import { format } from "date-fns";
import { LogRepository } from "../repositories/log.repository";

export class StorageTransport {
  constructor(
    private logRepo: LogRepository,
    private logs: WritableSignal<any>,
  ) {}

  private sanitizeLog = (log: any) => {
    const seen = new WeakMap();
    const sanitize = (value: any) => {
      if (typeof value === "function") {
        return "[Function]";
      }
      if (value && typeof value === "object") {
        if (seen.has(value)) {
          return "[Circular Reference]";
        }
        seen.set(value, true);
        const sanitizedObj = Object.keys(value).reduce((acc: any, key) => {
          acc[key] = sanitize(value[key]);
          return acc;
        }, {});
        seen.delete(value);
        return sanitizedObj;
      }
      return value;
    };
    return sanitize(log);
  };

  private getError = (message: any, additional: any) => {
    if (message instanceof Error) {
      return message;
    }
    if (additional instanceof Error) {
      return additional;
    }
    if (message instanceof Object && message?.error instanceof Error) {
      return message.error;
    }
    if (additional instanceof Object && additional?.error instanceof Error) {
      return additional.error;
    }
    return undefined;
  };

  public log(info: any) {
    const { level, dts, message, additional, ...rest } = info;
    const timestamp = format(dts, "yyyy-MM-dd HH:mm:ss");
    const output = { level, timestamp, dts, ...rest };
    const error = this.getError(message, additional);
    const stack = error?.stack as string | undefined;
    const errorMessage = error?.message as string | undefined;
    if (error || message instanceof Object) {
      const logRecordWithError = {
        ...(!(message instanceof Error) && message instanceof Object
          ? { ...message }
          : { message: message.message || message }),
        ...output,
        ...(additional instanceof Error ? {} : { ...additional }),
        ...(error ? { error: { message: errorMessage, stack } } : {}),
      };
      const sanitizedLogRecordWithError = this.sanitizeLog(logRecordWithError);
      this.logs.set([...this.logs(), sanitizedLogRecordWithError]);
      return this.logRepo.saveRecord("logID", sanitizedLogRecordWithError);
    }
    const logRecord = {
      ...output,
      ...additional,
      message: message?.message || message,
    };
    const sanitizedLogRecord = this.sanitizeLog(logRecord);
    this.logs.set([...this.logs(), sanitizedLogRecord]);
    return this.logRepo.saveRecord("logID", sanitizedLogRecord);
  }
}
